import TripCheckoutModule from './checkout/trip-checkout-module';
import ServicesModule from './../../services/services-module';
import SupplierModule from './../supplier/supplier-module';
import TravellersModule from './travellers/travellers-module';
import TripAddToCalendarModule from './trip-add-to-calendar/trip-add-to-calendar-module';
import TripCancellationModule from './trip-cancellation/trip-cancellation-module';
import TripItemCancellationModule from './trip-item-cancellation/trip-item-cancellation-module';
import TripItemCancellationMessageModule from './trip-item-cancellation-message/trip-item-cancellation-message-module';
import TripChangeTicketModule from './trip-change-ticket/trip-change-ticket-module';
import TripChangeEuRailTicketModule from './trip-change-eurail-ticket/trip-change-eurail-ticket-module';
import TripItemGroupModule from './trip-item-group/trip-item-group-module';
import TripItemEuRailJourneyModule from './trip-item-eurail-journey/trip-item-eurail-journey-module';
import TripItemRecommendationModule from './trip-item-recommendation/trip-item-recommendation-module';
import PaymentCodesModule from './payment-codes/payment-codes-module';
import TripAvailabilityModule from './checkout/trip-availability-item/trip-availability-item-module';
import TripTravellerAllocationModule from './checkout/trip-traveller-allocation/trip-traveller-allocation-module';
import TripFlightPassengerSeatInfoModule from './trip-flight-passenger-seat-info/trip-flight-passenger-seat-info-module';
import TripApprovalModule from './trip-approval/trip-approval-module';
import TripJustificationModule from './trip-justification/trip-justification-module';
import TripRoutes from './trip-routes';
import TripApproverOverride from './trip-approver-override/trip-approval-override-module';

import actionTripMessages from './config/actionTripMessages.constant';
import tripElementsTypesMap from './config/elementsTypesMap.constant';
import tripEvents from './config/events.constant';
import tripItems from './config/items.constant';
import reviewItemStatuses from './config/reviewItemStatuses.constant';
import tripStatesMap from './config/statesMap.constant';
import tripConstants from './config/trip.constant';
import tripCanBeBookStatuses from './config/tripCanBeBookedStatuses.constant';

import TripCheckoutHotelController from './controllers/checkout/trip-checkout-hotel-controller';
import TripCheckoutTermsController from './controllers/checkout/trip-checkout-terms-controller';
import TripCheckoutLuggageController from './controllers/checkout/tripCheckoutLuggageController';
import TripCheckoutModalController from './controllers/checkout/tripCheckoutModalCtrl';
import TripCheckoutPaymentCodesController from './payment-codes/tripCheckoutPaymentCodesController';
import TripCheckoutTravellersController from './controllers/checkout/tripCheckoutTravellersController';
import TripDetailsApproveFormController from './controllers/details/tripDetailsApproveFormController';
import TripDetailsController from './controllers/details/tripDetailsController';
import TripDetailsOrderListController from './controllers/details/tripDetailsOrderListController';
import TripDetailsRequestChangeController from './controllers/details/tripDetailsRequestChangeController';
import TripDetailsReviewController from './controllers/details/tripDetailsReviewController';
import TripDetailsSendController from './controllers/details/tripDetailsSendController';
import TripDetailsTravellersController from './controllers/details/tripDetailsTravellersController';

import ChildTraveller from './directives/childTraveller.directive';
import InfantTraveller from './directives/infantTraveller.directive';
import FlightRoute from './directives/ktFlightRoute.directive';
import VerificationHistory from './directives/ktVerificationHistory.directive';
import LuggageForm from './directives/luggageForm.directive';
import RejectedFlight from './directives/rejectedFlights.directive';
import TripCarItem from './directives/tripCarItem.directive';
import TripFlightItem from './directives/tripFlightItem.directive';
import TripHotelItem from './directives/trip-hotel-item-component';
import Capitalize from './services/capitalizeFilter';
import PricesCombined from './services/priceFilter';

import CheckoutAllocationService from './allocation/checkout-allocation-service';
import TripCheckoutModel from './controllers/checkout/trip-checkout-model';
import LuggageService from './services/luggageService';
import TripService from './trip-service';
import PaymentFactory from './services/paymentFactory';
import ToleranceHelper from './services/tolerance-helper.factory';
import TravellerService from './services/traveller-utils-service';
import TripAPI from './services/tripAPI';
import TripBookingModal from './services/tripBookingModal';
import TripFactory from './services/tripFactory';
import TripDetailsService from './services/trip-details-service';
import TripListService from './list/trip-list-service';
import TripOptionsService from './services/trip-options-service';
import TripBookingService from './trip-booking/trip-booking-service';
import ReviewConstructor from './services/tripReviewConstructor.factory';
import TripUtils from './services/tripUtils';
import UserReviewConstructor from './services/userReviewConstructor.factory';
import TripUCLTermsModule from './trip-ucl-terms/trip-ucl-terms-module';

const MODULE_NAME = 'App.Trip';
const module = angular
    .module(MODULE_NAME, [
        'ui.router',
        ServicesModule,
        SupplierModule,
        TripAddToCalendarModule,
        TripCancellationModule,
        TripItemCancellationModule,
        TripItemCancellationMessageModule,
        TripChangeTicketModule,
        TripChangeEuRailTicketModule,
        TripItemGroupModule,
        TripItemEuRailJourneyModule,
        TripItemRecommendationModule,
        PaymentCodesModule,
        TripAvailabilityModule,
        TripFlightPassengerSeatInfoModule,
        TripTravellerAllocationModule,
        TripApprovalModule,
        TripUCLTermsModule,
        TravellersModule,
        TripCheckoutModule,
        TripJustificationModule,
        TripApproverOverride,
    ])
    .constant('actionTripMessages', actionTripMessages)
    .constant('TRIP_ELEMENTS_TYPES_MAP', tripElementsTypesMap)
    .constant('tripEvents', tripEvents)
    .constant('TRIP_ITEMS', tripItems)
    .constant('REVIEW_ITEM_STATUSES', reviewItemStatuses)
    .constant('TRIP_STATES_MAP', tripStatesMap)
    .constant('TRIP_CONSTANTS', tripConstants)
    .constant('TRIP_CAN_BE_BOOK_STATUSES', tripCanBeBookStatuses)

    .filter('capitalize', Capitalize)
    .filter('pricesCombined', PricesCombined)

    .service('tripCheckoutModel', TripCheckoutModel)
    .service('tripListService', TripListService)
    .service('tripBookingService', TripBookingService)
    .service('checkoutAllocationService', CheckoutAllocationService)

    .factory('luggageService', LuggageService)
    .factory('paymentFactory', PaymentFactory)
    .factory('toleranceHelper', ToleranceHelper)
    .factory('travellerUtils', TravellerService)
    .factory('tripAPI', TripAPI)
    .service('tripBookingModal', TripBookingModal)
    .factory('tripFactory', TripFactory)
    .service('tripDetailsService', TripDetailsService)
    .service(TripService.SERVICE_NAME, TripService)
    .service('tripOptionsService', TripOptionsService)
    .factory('ReviewConstructor', ReviewConstructor)
    .factory('tripUtils', TripUtils)
    .factory('UserReviewConstructor', UserReviewConstructor)

    .directive('childTraveller', ChildTraveller)
    .directive('infantTraveller', InfantTraveller)
    .directive('ktFlightRoute', FlightRoute)
    .directive('ktVerificationHistory', VerificationHistory)
    .directive('luggageForm', LuggageForm)
    .directive('rejectedFlight', RejectedFlight)
    .directive('tripCarItem', TripCarItem)
    .directive('tripFlightItem', TripFlightItem)
    .directive('tripHotelItem', TripHotelItem)

    .controller('TripCheckoutHotelController', TripCheckoutHotelController)
    .controller('TripCheckoutTermsController', TripCheckoutTermsController)
    .controller('TripCheckoutLuggageController', TripCheckoutLuggageController)
    .controller('ModalController', TripCheckoutModalController)
    .controller('TripCheckoutPaymentCodesController', TripCheckoutPaymentCodesController)
    .controller('TripCheckoutTravellersController', TripCheckoutTravellersController)
    .controller('TripDetailsApproveFormController', TripDetailsApproveFormController)
    .controller('TripDetailsController', TripDetailsController)
    .controller('TripDetailsOrderListController', TripDetailsOrderListController)
    .controller('TripDetailsRequestChangeController', TripDetailsRequestChangeController)
    .controller('TripDetailsReviewController', TripDetailsReviewController)
    .controller('TripDetailsSendController', TripDetailsSendController)
    .controller('TripDetailsTravellersController', TripDetailsTravellersController)
    .config(TripRoutes);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-module.js